module.exports = __webpack_public_path__ + "static/media/besins.c5845dbf.png";